import { useEffect, useRef } from 'react';
import { useCancelJobAssignment } from '../dispatchPlus/Dispatch/Jobs/Job/CancelJobAssignment/useCancelJobAssignment.hook';

export const CancelJobAssignment = ({ isOpen, ...selectedDayJobToRemove }) => {
    const showModalRef = useRef(false);

    const handleRemoveDayJob = useCancelJobAssignment(selectedDayJobToRemove);

    useEffect(() => {
        if (isOpen && isOpen !== showModalRef.current) {
            handleRemoveDayJob();
        }

        showModalRef.current = isOpen;
    }, [isOpen, handleRemoveDayJob]);

    return null;
};